var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "saas-page linear-page" }, [
    _c("section", { staticClass: "linear-hero" }, [
      _c("div", [
        _c(
          "p",
          { staticClass: "linear-kicker" },
          [
            _c("router-link", { attrs: { to: "/home" } }, [
              _vm._v(_vm._s(_vm.trans("general.home"))),
            ]),
            _vm._v(" "),
            _c("span", [_vm._v("/")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.trans("auth.change_password")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c("h1", [_vm._v(_vm._s(_vm.trans("auth.change_password")))]),
        _vm._v(" "),
        _c("p", { staticClass: "linear-copy" }, [
          _vm._v(
            "Refresh your admin credentials with a short, focused security flow."
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "linear-command-card" }, [
        _c("span", { staticClass: "linear-dot" }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.trans("auth.password")))]),
        _vm._v(" "),
        _c("kbd", [_vm._v("Secure")]),
      ]),
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "linear-card" }, [
      _c("div", { staticClass: "linear-card__head" }, [
        _c("div", [
          _c("span", { staticClass: "linear-label" }, [
            _vm._v(_vm._s(_vm.trans("auth.password"))),
          ]),
          _vm._v(" "),
          _c("h2", [_vm._v(_vm._s(_vm.trans("auth.change_password")))]),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "linear-status" }, [_vm._v("Protected")]),
      ]),
      _vm._v(" "),
      _c(
        "form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.changePassword.apply(null, arguments)
            },
            keydown: function ($event) {
              return _vm.passwordForm.errors.clear($event.target.name)
            },
          },
        },
        [
          _c("div", { staticClass: "linear-form-grid" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("label", [
                  _vm._v(_vm._s(_vm.trans("auth.current_password"))),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.passwordForm.current_password,
                      expression: "passwordForm.current_password",
                    },
                  ],
                  staticClass: "form-control linear-input",
                  attrs: {
                    type: "password",
                    value: "",
                    name: "current_password",
                    placeholder: _vm.trans("auth.current_password"),
                    autocomplete: "current-password",
                  },
                  domProps: { value: _vm.passwordForm.current_password },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.passwordForm,
                        "current_password",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("show-error", {
                  attrs: {
                    "form-name": _vm.passwordForm,
                    "prop-name": "current_password",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("label", [_vm._v(_vm._s(_vm.trans("auth.new_password")))]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.passwordForm.new_password,
                      expression: "passwordForm.new_password",
                    },
                  ],
                  staticClass: "form-control linear-input",
                  attrs: {
                    type: "password",
                    name: "new_password",
                    placeholder: _vm.trans("auth.new_password"),
                    autocomplete: "new-password",
                  },
                  domProps: { value: _vm.passwordForm.new_password },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.passwordForm,
                        "new_password",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("show-error", {
                  attrs: {
                    "form-name": _vm.passwordForm,
                    "prop-name": "new_password",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("label", [
                  _vm._v(_vm._s(_vm.trans("auth.new_password_confirmation"))),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.passwordForm.new_password_confirmation,
                      expression: "passwordForm.new_password_confirmation",
                    },
                  ],
                  staticClass: "form-control linear-input",
                  attrs: {
                    type: "password",
                    value: "",
                    name: "new_password_confirmation",
                    placeholder: _vm.trans("auth.new_password_confirmation"),
                    autocomplete: "new-password",
                  },
                  domProps: {
                    value: _vm.passwordForm.new_password_confirmation,
                  },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.passwordForm,
                        "new_password_confirmation",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("show-error", {
                  attrs: {
                    "form-name": _vm.passwordForm,
                    "prop-name": "new_password_confirmation",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "linear-actions" }, [
            _c(
              "button",
              {
                staticClass:
                  "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                attrs: { type: "submit" },
              },
              [_vm._v(_vm._s(_vm.trans("auth.change_password")))]
            ),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }